require('./angular-ui-switch.css');
require('./angular-ui-switch.js');
module.exports = 'uiSwitch';



//////////////////
// WEBPACK FOOTER
// ./~/angular-ui-switch/index.js
// module id = 1100
// module chunks = 1